import React, { useEffect } from 'react';

interface ZapierModalProps {
  isOpen: boolean;
  onClose: () => void;
  userEmail?: string;
  userFirstName?: string;
  userLastName?: string;
}

const ZAPIER_CSS = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css';
const ZAPIER_SCRIPT = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js';

export default function ZapierModal({
  isOpen,
  onClose,
  userEmail = 'email_of_your_user@example.com',
  userFirstName = 'first_name_of_your_user',
  userLastName = 'last_name_of_your_user',
}: ZapierModalProps) {
  useEffect(() => {
    // Only load Zapier resources once
    if (!document.querySelector(`link[href="${ZAPIER_CSS}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = ZAPIER_CSS;
      document.head.appendChild(link);
    }
    if (!document.querySelector(`script[src="${ZAPIER_SCRIPT}"]`)) {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = ZAPIER_SCRIPT;
      document.head.appendChild(script);
    }
  }, []);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="bg-white rounded-lg p-6 w-full max-w-3xl max-h-[90vh] overflow-auto"
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Connect with Zapier</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
            aria-label="Close Zapier Modal"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <zapier-workflow
          sign-up-email={userEmail}
          sign-up-first-name={userFirstName}
          sign-up-last-name={userLastName}
          client-id="xQ8hJPnfcAJqJa6oblyB8huqP7lkSvmM8g2fKN4s"
          theme="light"
          intro-copy-display="hide"
          guess-zap-display="hide"
          app-search-bar-display="show"
          app-limit={2}
          app-categories="sales-crm"
        />
      </div>
    </div>
  );
}
